// Module
var code = "<wt-generic-search-bar criteria=\"vm.criteria\" filtered-items=\"vm.filtered\" items=\"vm.tags\" placeholder=\"Search for tags (t:tag i:identifier g:group u:unit c:comment v:variable so:source)\"> </wt-generic-search-bar>";
// Exports
module.exports = code;